//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { liaisonCreateApi, liaisonSaveApi, liaisonEditCreateApi, liaisonEditSaveApi } from '@/api/enterprise';
export default {
  name: 'liaisonDialog',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    oaForm: function oaForm() {
      return import('@/components/customer/oaForm');
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      fromInfo: [],
      row: {},
      customInfo: {},
      contractFromData: {},
      edit: ''
    };
  },
  methods: {
    // 新增联系人表单
    getData: function getData() {
      var _this = this;
      liaisonCreateApi().then(function (res) {
        _this.fromInfo = res.data;
      });
    },
    handleClose: function handleClose() {
      this.drawer = false;
      this.$refs.oaForm.resetForm();
    },
    // 编辑联系人表单
    getEditData: function getEditData(id) {
      var _this2 = this;
      liaisonEditCreateApi(id).then(function (res) {
        _this2.fromInfo = res.data;
      });
    },
    // 提交成功
    submitOk: function submitOk(data) {
      var _this3 = this;
      data.eid = this.customInfo.id;
      if (this.edit === 'edit') {
        liaisonEditSaveApi(this.row.id, data).then(function (res) {
          if (res.status == 200) {
            _this3.drawer = false;
            _this3.$emit('isLiaison');
            _this3.$refs.oaForm.resetForm();
          }
        }).catch(function (err) {
          _this3.$refs.oaForm.resetForm();
        });
      } else {
        liaisonSaveApi(data).then(function (res) {
          if (res.status == 200) {
            _this3.drawer = false;
            _this3.$emit('isLiaison');
            _this3.$refs.oaForm.resetForm();
          }
        }).catch(function (err) {
          _this3.$refs.oaForm.resetForm();
        });
      }
    },
    openBox: function openBox(row, customInfo, edit) {
      this.edit = edit;
      if (customInfo) {
        this.customInfo = customInfo;
      }
      if (row) {
        this.row = row;
        this.getEditData(row.id);
      } else {
        this.getData();
      }
      this.drawer = true;
    }
  }
};